import script from "./StylesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StylesModal.vue?vue&type=script&setup=true&lang=js"

import "./StylesModal.vue?vue&type=style&index=0&id=34ef4548&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ef4548"]])

export default __exports__